export class Key {
  static get BACKSPACE(): string {
    return 'Backspace';
  }

  static get DOWN_ARROW(): string {
    return 'ArrowDown';
  }

  static get DELETE(): string {
    return 'Delete';
  }

  static get ENTER(): string {
    return 'Enter';
  }

  static get ESCAPE(): string {
    return 'Escape';
  }

  static get LEFT_ARROW(): string {
    return 'ArrowLeft';
  }

  static get RIGHT_ARROW(): string {
    return 'ArrowRight';
  }

  static get UP_ARROW(): string {
    return 'ArrowUp';
  }
}
